import { render, staticRenderFns } from "./compareDetails.vue?vue&type=template&id=73b4dea2"
import script from "./compareDetails.vue?vue&type=script&lang=js"
export * from "./compareDetails.vue?vue&type=script&lang=js"
import style0 from "./compareDetails.vue?vue&type=style&index=0&id=73b4dea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports